import { Folio } from "src/app/models/Folio/Folio";

export interface FolioSummary {
	tipoDteId: string;
	nombre: string;
	codigoSii: number;
	suma: number;
}

export function resumirFolios(folios: Folio[], obtenerNombre: (tipoDteId: string) => string): FolioSummary[] {
	const grupos = (folios || []).reduce((resultado, folio) => {
		const existentes = resultado.get(folio.tipoDteId) || [];
		existentes.push(folio);
		resultado.set(folio.tipoDteId, existentes);
		return resultado;
	}, new Map<string, Folio[]>());

	return Array.from(grupos.entries())
		.map(([tipoDteId, grupo]) => ({
			tipoDteId,
			nombre: obtenerNombre(tipoDteId),
			codigoSii: grupo[0].codigoSii,
			suma: grupo.filter((folio) => folio.activo).reduce((total, folio) => total + Number(folio.foliosDisponibles || 0), 0),
		}))
		.sort((a, b) => a.nombre.localeCompare(b.nombre));
}
